import React from 'react';
import { Backdrop, styled } from '@mui/material';
import PropTypes from 'prop-types';

// Backdrop estilizado com diferentes variações
const StyledBackdrop = styled(Backdrop, {
  shouldForwardProp: (prop) => prop !== 'backdropType',
})(({ theme, backdropType }) => ({
  zIndex: -1,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.standard,
  }),

  // Variações de fundo
  ...(backdropType === 'blur' && {
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)', // Para compatibilidade com Safari
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  }),

  ...(backdropType === 'gradient' && {
    background: `linear-gradient(135deg, 
      ${theme.palette.primary.dark}30 0%, 
      ${theme.palette.primary.main}20 40%, 
      ${theme.palette.secondary.dark}30 100%)`,
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
  }),
}));

const ModalBackdrop = ({ backdropType, open, ...other }) => {
  return (
    <StyledBackdrop
      open={open}
      backdropType={backdropType}
      {...other}
    />
  );
};

ModalBackdrop.propTypes = {
  open: PropTypes.bool,
  backdropType: PropTypes.oneOf(['blur', 'gradient']),
};

export default ModalBackdrop;